const COINGECKO_API_URL =
  "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=tradestars&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=24h";

class TSXService {
  private static bfInternal: TSXService;

  static get Instance(): TSXService {
    if (TSXService.bfInternal === undefined) {
      TSXService.bfInternal = new TSXService();
    }
    return TSXService.bfInternal;
  }

  public async tokenValues(): Promise<any> {
    return this._fetch(COINGECKO_API_URL);
  }

  /* tslint:disable:no-string-literal */
  private async _fetch(uri: string): Promise<any> {
    const response = await fetch(uri);

    if (!response.ok) {
      throw Error(response.statusText);
    }

    return response.json();
  }
  /* tslint:enable:no-string-literal */
}

export default TSXService.Instance;
